import React from 'react';
import PropTypes from 'prop-types';

const OVERLAY_STYLE = {
  backgroundImage:
    'radial-gradient(circle at 20% 20%, rgba(255,255,255,.8), transparent 55%),' +
    'radial-gradient(circle at 80% 30%, rgba(255,255,255,.6), transparent 55%)',
};

const NewsHeaderCard = ({ eyebrow, title, description, children }) => (
  <header className="rounded-md border border-gray-300 bg-white overflow-hidden">
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-[color:var(--brand)]" />
      <div
        className="absolute inset-0 opacity-15"
        style={OVERLAY_STYLE}
        aria-hidden="true"
      />
      <div className="relative p-4 sm:p-6 md:p-7 text-white">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-wider text-white/90">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-1 text-h2 sm:text-h1 font-semibold">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-white/90 max-w-3xl">{description}</p>
        )}
      </div>
    </div>
  </header>
);

NewsHeaderCard.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  children: PropTypes.node,
};

NewsHeaderCard.defaultProps = {
  eyebrow: 'Sala de imprensa',
};

export default NewsHeaderCard;
